import router from './router';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { Route, RouteConfig } from 'vue-router';
import { UserModule } from '@/store/modules/user';
import { asyncRoutes } from '@/utils/async-routes';
import { generateRoutes } from './utils/filter-routes';
NProgress.configure({ showSpinner: false });

const whiteList = ['/login'];
let flag = false;
router.beforeEach(async (to: Route, _: Route, next: any) => {
  // Start progress bar
  NProgress.start();

  // Determine whether the user has logged in
  if (UserModule.token) {
    if (!UserModule.roles || UserModule.roles.length === 0) {
      UserModule.ResetToken();
      next(`/login?redirect=${to.path}`);
      NProgress.done();
      return;
    }
    if (to.path === '/login') {
      // If is logged in, redirect to the home page
      next({ path: '/' });
      NProgress.done();
    } else {
      if (!flag) {
        try {
          // Get user info, including roles
          // await UserModule.GetUserInfo();
          // Set the replace: true, so the navigation will not leave a history record
          const filterRoutes = generateRoutes(asyncRoutes);
          router.addRoutes(filterRoutes);
          (router as any).options.routes.push(...filterRoutes);

          flag = true;
          next({ ...to, replace: true });
        } catch (err) {
          // Remove token and redirect to login page
          UserModule.ResetToken();
          next(`/login?redirect=${to.path}`);
          NProgress.done();
        }
      } else {
        next();
      }
    }
  } else {
    // Has no token
    if (whiteList.indexOf(to.path) !== -1) {
      // In the free login whitelist, go directly
      next();
    } else {
      // Other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`);
      NProgress.done();
    }
  }
});

router.afterEach((to: Route) => {
  // Finish progress bar
  NProgress.done();

  // set page title
  document.title = to.meta!.title;
});
